// extracted by mini-css-extract-plugin
export var boldText = "_6v-4";
export var checkboxContainer = "_6v-6";
export var closeIcon = "_6v-i";
export var container = "_6v-0";
export var drawer = "_6v-8";
export var drawerContent = "_6v-9";
export var extraSmallText = "_6v-5";
export var fulfillmentGroupTable = "_6v-e";
export var largeText = "_6v-3";
export var loadingSpinnerContainer = "_6v-j";
export var mediumText = "_6v-2";
export var narrow = "_6v-f";
export var notificationLink = "_6v-l";
export var packageCheckIconContainer = "_6v-7";
export var slideoutHeaderActions = "_6v-g";
export var slideoutHeaderActionsShifted = "_6v-h";
export var slideoutHeaderContainer = "_6v-a";
export var slideoutModal = "_6v-c";
export var stickyHeaderWrapper = "_6v-b";
export var table = "_6v-k";
export var tableContainer = "_6v-d";
export var tertiaryText = "_6v-1";